'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _lodash = require('lodash');

var _FieldStyle = require('./FieldStyle.scss');

var _FieldStyle2 = _interopRequireDefault(_FieldStyle);

var _ = require('./');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Field = (_dec = (0, _reactCssModules2.default)(_FieldStyle2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Field, _React$Component);

  function Field() {
    (0, _classCallCheck3.default)(this, Field);
    return (0, _possibleConstructorReturn3.default)(this, (Field.__proto__ || (0, _getPrototypeOf2.default)(Field)).apply(this, arguments));
  }

  (0, _createClass3.default)(Field, [{
    key: 'fieldHasError',
    value: function fieldHasError(name) {
      var errors = this.props.errors;

      return errors && (0, _lodash.has)(errors, name) || errors && errors.messages && (0, _lodash.has)(errors.messages, name);
    }
  }, {
    key: 'fieldError',
    value: function fieldError(name) {
      var errors = this.props.errors;

      if (errors[name]) {
        return errors[name][0];
      }

      return errors.messages[name][0];
    }
  }, {
    key: 'baseFieldClass',
    value: function baseFieldClass() {
      if (this.props.inputType === 'radio') {
        return 'm-formField m-formField--radio';
      }

      return 'm-formField';
    }
  }, {
    key: 'fieldClass',
    value: function fieldClass() {
      if (this.fieldHasError(this.props.inputName)) {
        return this.baseFieldClass() + ' m-formField--invalid ' + this.props.additionalStyles;
      }

      return this.baseFieldClass() + ' ' + this.props.additionalStyles;
    }
  }, {
    key: 'renderRequired',
    value: function renderRequired() {
      if (!this.props.fieldRequired) {
        return '';
      }

      return _react2.default.createElement(
        'span',
        { styleName: 'a-required' },
        '*'
      );
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      if (!this.props.inputLabel) {
        return '';
      }

      return _react2.default.createElement(
        _.Label,
        { htmlFor: this.props.inputName },
        this.props.inputLabel,
        this.renderRequired()
      );
    }
  }, {
    key: 'renderError',
    value: function renderError(name) {
      if (!this.fieldHasError(name)) {
        return '';
      }

      var error = this.fieldError(name);
      var requiresInputName = !/^[A-Z]/.test(error);
      var message = requiresInputName ? this.props.inputLabel + ' ' + error : error;

      return _react2.default.createElement(
        _.Label,
        { htmlFor: name, className: 'a-label a-label--error' },
        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: message } })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: this.fieldClass() },
        this.renderLabel(),
        this.props.children,
        this.renderError(this.props.inputName)
      );
    }
  }]);
  return Field;
}(_react2.default.Component), _class2.propTypes = {
  errors: _react.PropTypes.object,
  inputName: _react.PropTypes.string.isRequired,
  inputType: _react.PropTypes.string,
  inputLabel: _react.PropTypes.string,
  additionalStyles: _react.PropTypes.string,
  fieldRequired: _react.PropTypes.bool
}, _class2.defaultProps = {
  additionalStyles: '',
  inputType: 'text',
  inputName: '',
  inputLabel: '',
  fieldRequired: false
}, _temp)) || _class);
exports.default = Field;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/Field.js
// module id = 2466
// module chunks = 0